// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"43c62797","523":"7a8cca37","950":"fa52300c"}[chunkId] + ".chunk.js";
};